<template>
  <div class="register-container">
    <div class="register-left">
      <div class="logo">
        <img src="https://filelsjc.tt65org.com/uploads/20260203/11d4e1a93ec5fc496e0f3af18b1bb2b5.png" alt="Logo" />
        <span>与绿同行</span>
      </div>
      <div class="illustration">
        <img src="https://filelsjc.tt65org.com/uploads/20260123/7ae10c30c4779acb7d27c6c45ffd7580.png" alt="Illustration" />
      </div>
    </div>
    <div class="register-right">
      <div class="register-box">
        <h2 class="welcome-title">用户注册</h2>
        <p class="welcome-subtitle">创建您的账户，开始项目申报</p>

        <el-form :model="registerForm" :rules="rules" ref="registerForm" class="register-form">
          <!-- 头像上传 -->
          <el-form-item prop="avatar" class="avatar-upload-item">
            <ImageUpload v-model="registerForm.avatar" :limit="1" :position="'center'"></ImageUpload>
          </el-form-item>
          
          <!-- 昵称输入 -->
          <el-form-item prop="nickname">
            <el-input v-model="registerForm.nickname" placeholder="请输入昵称" prefix-icon="el-icon-user"></el-input>
          </el-form-item>
          
          <el-form-item prop="phone">
            <el-input v-model="registerForm.phone" placeholder="建议使用常用手机号" prefix-icon="el-icon-mobile-phone">
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input type="password" v-model="registerForm.password" placeholder="请设置密码" prefix-icon="el-icon-lock"></el-input>
          </el-form-item>
          <!-- <el-form-item prop="confirmPassword">
            <el-input type="password" v-model="registerForm.confirmPassword" placeholder="请确认密码" prefix-icon="el-icon-lock"></el-input>
          </el-form-item> -->
          <el-form-item prop="code">
            <div class="code-input-group">
              <el-input v-model="registerForm.code" placeholder="请输入验证码" prefix-icon="el-icon-message"></el-input>
              <el-button :disabled="countdown > 0" @click="sendCode" class="code-btn">
                {{ countdown > 0 ? `${countdown}s后重新获取` : '获取验证码' }}
              </el-button>
            </div>
          </el-form-item>
          <!-- <el-form-item>
            <el-checkbox v-model="agreeProtocol">我已阅读并同意《用户服务协议和隐私政策》</el-checkbox>
          </el-form-item> -->
          <el-form-item>
            <el-button type="primary" @click="handleRegister" :loading="loading" class="register-btn">立即注册</el-button>
          </el-form-item>
        </el-form>
        <div class="back-login">
          已有账号？<span @click="goLogin">立即登录</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { register, sendSms, checkSmsCorrect } from '@/api/signUp'

export default {
  name: 'Register',
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.registerForm.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      registerForm: {
        avatar: '',
        nickname: '',
        phone: '',
        password: '',
        code: '',
        addby:'网站'
      },
      rules: {
        avatar: [
          { required: true, message: '请上传头像', trigger: 'change' },
        ],
        nickname: [
          { required: true, message: '请输入昵称', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请设置密码', trigger: 'blur' },
        ],
        confirmPassword: [
          { required: true, message: '请确认密码', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' },
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
        ],
      },
      agreeProtocol: false,
      countdown: 0,
      timer: null,
      loading: false,
    };
  },
  methods: {
    // 头像上传前的验证
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;
      
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 或 PNG 格式!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
        return false;
      }
      return true;
    },
    // 头像文件改变处理
    handleAvatarChange(file) {
      if (this.beforeAvatarUpload(file.raw)) {
        // 创建预览URL
        const reader = new FileReader();
        reader.onload = (e) => {
          this.registerForm.avatar = e.target.result;
        };
        reader.readAsDataURL(file.raw);
      }
    },
    // 发送验证码
    sendCode() {
      if (this.countdown > 0) return;
      
      this.$refs.registerForm.validateField('phone', (error) => {
        if (!error) {
          sendSms({
            phone: this.registerForm.phone,
            event: 'mobilelogin'
          }).then(() => {
            this.$message.success('验证码已发送');
            this.startCountdown();
          }).catch(() => {
            this.$message.error('发送验证码失败');
          });
        }
      });
    },
    // 开始倒计时
    startCountdown() {
      this.countdown = 60;
      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    },
    // 注册
    handleRegister() {
      this.$refs.registerForm.validate((valid) => {
        if (valid) {
          this.loading = true;

          register({
              avatar: this.registerForm.avatar,
              nickname: this.registerForm.nickname,
              mobile: this.registerForm.phone,
              captcha: this.registerForm.code,
              password: this.registerForm.password,
              openid: '',
              unionid: '',
              addby: this.registerForm.addby,
            }).then(response => {
              console.log(response);
              if(response.data.code == 1) {
                this.$message.success('注册成功');
                this.$router.push('/');
              } else {
                this.$message.error(response.data.msg);
              }
            })

        }
      });
    },
    // 返回登录页
    goLogin() {
      this.$router.push('/');
    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
};
</script>

<style>
body {
	margin: 0;
}
</style>

<style scoped>
.register-container {
	display: flex;
	height: 100vh;
	overflow: hidden;
}

.register-left {
	flex: 1;
	background: linear-gradient(135deg, #289c52 0%, #289c52 100%);
	color: white;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 60px 40px;
	position: relative;
}

.logo {
	display: flex;
	align-items: center;
	gap: 12px;
	position: absolute;
	top: 40px;
	left: 40px;
	font-size: 20px;
	font-weight: bold;
}

.logo img {
	width: 40px;
	height: 40px;
	border-radius: 8px;
}

.illustration {
	margin: 40px 0;
}

.illustration img {
	max-width: 900px;
	height: auto;
	border-radius: 12px;
}

.slogan {
	text-align: center;
	margin: 30px 0;
}

.slogan h3 {
	font-size: 28px;
	margin: 0 0 16px 0;
	font-weight: 600;
}

.slogan p {
	font-size: 16px;
	margin: 0;
	opacity: 0.9;
}

.register-right {
	flex: 1;
	background: white;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 40px;
}

.register-box {
	width: 100%;
	max-width: 400px;
}

.welcome-title {
	font-size: 32px;
	color: #333;
	margin: 0 0 12px 0;
	font-weight: 600;
}

.welcome-subtitle {
	color: #666;
	margin: 0 0 32px 0;
	font-size: 14px;
}

.register-form {
	width: 100%;
}

.code-input-group {
	display: flex;
	gap: 12px;
}

.code-input-group .el-input {
	flex: 1;
}

.code-btn {
	width: 120px;
	height: 40px;
	flex-shrink: 0;
}

.register-btn {
	width: 100%;
	height: 48px;
	font-size: 16px;
	font-weight: 500;
}

.back-login {
	text-align: center;
	margin-top: 24px;
	color: #666;
	font-size: 14px;
}

.back-login span {
	color: #409eff;
	cursor: pointer;
	text-decoration: underline;
}

.back-login span:hover {
	color: #66b1ff;
}

.el-form-item {
	margin-bottom: 24px;
}

.el-input {
	height: 48px;
}

.el-input__inner {
	height: 48px;
	line-height: 48px;
	border-radius: 8px;
}

.el-input-group__prepend {
	background-color: #f5f7fa;
	border-color: #dcdfe6;
	color: #606266;
}

/* 头像上传样式 */
.avatar-upload-item {
  display: flex;
	justify-content: center;
	align-items: center;
	margin-bottom: 32px;
}

.avatar-upload-container {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.avatar-uploader {
	display: flex;
	justify-content: center;
	align-items: center;
}

.avatar-uploader .el-upload {
	border: 2px dashed #d9d9d9;
	border-radius: 50%;
	cursor: pointer;
	position: relative;
	overflow: hidden;
	transition: all 0.3s ease;
	width: 100px;
	height: 100px;
	display: flex;
	justify-content: center;
	align-items: center;
}

.avatar-uploader .el-upload:hover {
	border-color: #409eff;
	background-color: #f0f9ff;
}

.avatar {
	width: 100px;
	height: 100px;
	border-radius: 50%;
	object-fit: cover;
	display: block;
}

.avatar-placeholder {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 100px;
	height: 100px;
	color: #8c939d;
	font-size: 12px;
	text-align: center;
}

.avatar-uploader-icon {
	font-size: 24px;
	margin-bottom: 8px;
}

.avatar-tips {
	margin-top: 12px;
	font-size: 12px;
	color: #999;
	text-align: center;
	line-height: 1.4;
}
</style>